import $ from 'jquery';

const resourceProgress = {
		
    init: function() {

        this.$resources = $('[data-js-progress="resources"]').children();
        this.getResourcesTotal();
        this.resourcesTotal;
        this.$button = $('[data-js-progress="resource-download"]');
        this.region = $('body').attr('data-js-region');
        this.completeResources = [];
        
        this.$progressBar = $('[data-js-progress="download-bar"]');
        this.$progressNum = $('[data-js-progress="download-num"]');

        
        
        this.eventHandlers();
        this.getProgress();
    },
    
    eventHandlers: function() {
        this.$button.on('click',this.download.bind(this));
    },

    getResourcesTotal() {
        if(this.localStorageTry()) {
            if(this.$resources.length) {
                localStorage.setItem('download-resource-total',this.$resources.length);
            }
            this.resourcesTotal = localStorage.getItem('download-resource-total');
        }
        
    },
    
    download: function(e) {
        var mediaID = $(e.currentTarget).attr('media-id');
        
        // adds the media ID to the completed media array so that the user gets immediate completion feedback
        if(this.completeResources.indexOf(mediaID) === -1) {
            this.completeResources.push(mediaID);
        }
        this.render();
        
        this.postDownload(mediaID);

    },
    
    postDownload: function(media) {
        
        // posts the media download to the backend then requests the progress again
        $.post(this.region + '/media-download',{
            version_id: media,
            region: this.region
        }).done(this.getProgress.bind(this));
    },
    
    getProgress: function() {
        
        // requests completion data then overwrites current data based on what's received
        
        $.get('/' + this.region + '/media-download').done(function(data){
            
            this.completeResources = data.data.progress;
            
            this.render();
        }.bind(this));
        
    },
    
    render: function() {
        
        this.markComplete();
        this.setPercentage();
    },
    
    markComplete: function() {
        
        $.each(this.completeResources,function(index,value) {
            
            var checkbox = $('[media-id="' + value + '"]').closest('[data-js-progress="resource"]').find('[data-js-progress="confirmation"]');
            
            checkbox.addClass('active');
            
        })
        
    },
    
    setPercentage: function() {
        
        let percentage = Math.round(this.completeResources.length / this.resourcesTotal * 100);

        if(percentage === Infinity) {
            percentage = 0;
        }
        
        this.$progressBar.css('width',percentage + '%');
        this.$progressNum.html(percentage + '%');
    },

    localStorageTry() {
        try {
            localStorage.setItem('test','test');
            localStorage.removeItem('test');
            return true;
        } catch(e) {
            return false;
        }
    }
}

$(document).ready(() => {
    resourceProgress.init();
})